import { IBook } from './types';
import { getBookTextInputData } from './inputs/text/utils';
import { getBookRadioInputData, getBookRadioInputOptionData } from './inputs/radio/utils';
import { getBookPriceData } from './prices/utils';
import { getBookSelectInputData, getBookSelectInputOptionData } from './inputs/select/utils';
import { months, days, getFilledNumbersArray } from 'src/app/shared/timepicker-select/timepicker-select.data';
import {
  BOOK_ALIAS_WHOS_BIRTHDAY_TOMORROW,
  INPUT_NAME_KIDS_NAME,
  INPUT_NAME_KIDS_BIRTHDAY_MONTH,
  INPUT_NAME_KIDS_BIRTHDAY_DAY,
  INPUT_NAME_AGE_TO_BE,
  INPUT_VALUE_GENDER_BOY,
  INPUT_VALUE_GENDER_GIRL,
  INPUT_NAME_GENDER,
  INPUT_VALUE_ANIMALS,
  INPUT_NAME_WHOS_CELEBRATING,
  INPUT_VALUE_DINOS,
  INPUT_VALUE_MONSTERS,
  BOOK_PRICE_WHOS_BIRTHDAY_TOMORROW,
  BOOK_PRICE_WHOS_BIRTHDAY_TOMORROW_HARD_COVER,
  INPUT_NAME_SEASON,
  INPUT_VALUE_TIME_OF_THE_YEAR_AUTUMN,
  INPUT_VALUE_TIME_OF_THE_YEAR_WINTER,
  INPUT_VALUE_TIME_OF_THE_YEAR_SPRING,
  INPUT_VALUE_TIME_OF_THE_YEAR_SUMMER,
} from '@shared/book/constants';
import { EBookBannerTextColor } from './banner/types';
import { EBookDescriptionTextItemType } from './desicription/types';
import StaryDream from './StaryDream';
import { getBookNameValidatorList } from 'src/app/validators';
import { GET_BOOK_NAME_ERROR } from 'src/app/validators.constants';

export const WhosBirthdayTomorrowInputsGender = getBookRadioInputData({
  label: '',
  options: [
    getBookRadioInputOptionData({
      label: 'Boy',
      imgSrc: '/assets/images/radio-boy-2.png',
      value: INPUT_VALUE_GENDER_BOY,
    }),
    getBookRadioInputOptionData({
      label: 'Girl',
      imgSrc: '/assets/images/radio-girl-2.png',
      value: INPUT_VALUE_GENDER_GIRL,
    }),
  ],
  value: INPUT_VALUE_GENDER_BOY,
  name: INPUT_NAME_GENDER,
});

export const WhosBirthdayTomorrowInputsKidsName = getBookTextInputData({
  label: 'Kid’s name',
  placeholder: 'ひらがな7文字まで',
  // value: '',
  name: INPUT_NAME_KIDS_NAME,
  validator: getBookNameValidatorList(7),
  error: GET_BOOK_NAME_ERROR(7),
});

export const WhosBirthdayTomorrowInputsKidsBirthdayMonth = getBookSelectInputData({
  label: 'Kid’s birthday',
  placeholder: 'mm',
  options: months.map(
    (month) => getBookSelectInputOptionData({ label: month, value: month }),
  ),
  // value: '',
  name: INPUT_NAME_KIDS_BIRTHDAY_MONTH,
});

export const WhosBirthdayTomorrowInputsKidsBirthdayDay = getBookSelectInputData({
  label: '',
  placeholder: 'dd',
  options: days.map(
    (day) => getBookSelectInputOptionData({ label: day, value: day }),
  ),
  // value: '',
  name: INPUT_NAME_KIDS_BIRTHDAY_DAY,
});

export const WhosBirthdayTomorrowInputsAgeToBe = getBookSelectInputData({
  label: 'もうすぐ',
  placeholder: '1~9yo',
  options: getFilledNumbersArray(1, 9, 1).map(
    (year) => getBookSelectInputOptionData({ label: year, value: year }),
  ),
  // value: '',
  name: INPUT_NAME_AGE_TO_BE,
});

export const WhosBirthdayTomorrowInputsWhosCelebrating = getBookRadioInputData({
  label: 'Who is celebrating the hero’s birthday?',
  options: [
    getBookRadioInputOptionData({
      label: 'Animals',
      imgSrc: '/assets/images/book2-animals.png',
      imgExpandTopPx: 13,
      imgExpandRightPx: 13,
      value: INPUT_VALUE_ANIMALS,
    }),
    getBookRadioInputOptionData({
      label: 'Dinos',
      imgSrc: '/assets/images/book2-dinos.png',
      imgExpandTopPx: 13,
      imgExpandRightPx: 13,
      value: INPUT_VALUE_DINOS,
    }),
    getBookRadioInputOptionData({
      label: 'Monsters',
      imgSrc: '/assets/images/book2-monsters.png',
      imgExpandTopPx: 13,
      imgExpandRightPx: 13,
      value: INPUT_VALUE_MONSTERS,
    }),
  ],
  value: INPUT_VALUE_ANIMALS,
  name: INPUT_NAME_WHOS_CELEBRATING,
});

export const WhosBirthdayTomorrowInputsSeason = getBookRadioInputData({
  label: '',
  placeholder: '',
  options: [
    getBookRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_SPRING,
      imgSrc: '/assets/images/season-step/b2_spring.png',
      imgExpandTopPx: 21,
      imgExpandRightPx: 35,
      imgExpandBottomPx: 5,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_SPRING,
    }),
    getBookRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_SUMMER,
      imgSrc: '/assets/images/season-step/b2_summer.png',
      imgExpandTopPx: 21,
      imgExpandRightPx: 35,
      imgExpandBottomPx: 5,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_SUMMER,
    }),
    getBookRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_AUTUMN,
      imgSrc: '/assets/images/season-step/b2_autumn.png',
      imgExpandTopPx: 21,
      imgExpandRightPx: 35,
      imgExpandBottomPx: 5,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_AUTUMN,
    }),
    getBookRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_WINTER,
      imgSrc: '/assets/images/season-step/b2_winter.png',
      imgExpandTopPx: 21,
      imgExpandRightPx: 35,
      imgExpandBottomPx: 5,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_WINTER,
    }),
  ],
  // value: '',
  name: INPUT_NAME_SEASON,
});

const WhosBirthdayTomorrow: IBook = {
  caption: 'Who’s birthday tomorrow?',
  summary: ['明日は一年のなかで一番、特別な日。最高のお誕生日パーティにしよう！'],
  alias: BOOK_ALIAS_WHOS_BIRTHDAY_TOMORROW,
  prices: [
    ['soft', getBookPriceData(BOOK_PRICE_WHOS_BIRTHDAY_TOMORROW)],
    ['hard', getBookPriceData(BOOK_PRICE_WHOS_BIRTHDAY_TOMORROW_HARD_COVER)],
  ],
  photos: [
    '/assets/images/book2-carousel01.jpg',
    '/assets/images/book2-carousel02.jpg',
    '/assets/images/book2-carousel03.jpg',
  ],
  menuPhoto: '/assets/images/cart-product-photo-2.png',
  previewPhoto: '/assets/images/book2-books.png',
  properties: {
    purpose: ['Birthday'],
    age: {
      start: 1,
      end: 5,
    },
  },
  notice: {
    caption: 'Best book birthday',
    description: 'birthday.description',
    points: [
      {
        imgSrc: '/assets/images/birthday-notice-point-1.png',
        caption: 'birthday.notice.point.1',
      },
      {
        imgSrc: '/assets/images/birthday-notice-point-2.png',
        caption: 'birthday.notice.point.2',
      },
    ],
  },
  points: [
    {
      caption: 'どんなカスタマイズができるの？',
      description: 'メッセージ編集、キャラクター選択など。お誕生日がカレンダーになったりしてイラストの中に何回も登場。',
    },
    {
      caption: '絵本のストーリーは？',
      description: 'もう寝る時間なのに、なんだか騒がしい人たちがいます。「明日はこの街に住むみんな大好きなあの子の誕生日だ！」と、はっちゃかめっちゃかにパーティの準備をします。さぁ、明日は誰の誕生日？',
    },
    {
      caption: 'ページ数や絵本の大きさは？',
      description: '全28ページ、本文の大きさは横21cm 高さ21cmの正方形。',
    },
  ],
  inputs: [
    WhosBirthdayTomorrowInputsKidsName,
    WhosBirthdayTomorrowInputsKidsBirthdayMonth,
    WhosBirthdayTomorrowInputsKidsBirthdayDay,
    WhosBirthdayTomorrowInputsAgeToBe,
    WhosBirthdayTomorrowInputsGender,
    WhosBirthdayTomorrowInputsWhosCelebrating,
  ],
  banner: {
    imgSrc: '/assets/images/book2-banner-desktop.png',
    imgSrcLtMd: '/assets/images/book2-banner-mobile.png',
    text: 'あしたは　このまちで　いっちばん　とくべつな　あのひ　である！',
    textColor: EBookBannerTextColor.dark,
  },
  description: [
    {
      imgSrc: '/assets/images/book2-images01.png',
      text: [
        {
          type: EBookDescriptionTextItemType.caption,
          text: '明日がとびっきり楽しみになる！'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: '明日はみんな大好きなあの子の誕生日！'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: '物語が進むにつれて明らかになる、そのパーティの主役の"あの子"って？あれれ、もしかして・・それってわたし/ぼくのこと？！',
        },
      ],
    }, {
      imgSrc: '/assets/images/book2-images02.gif',
      text: [
        {
          type: EBookDescriptionTextItemType.caption,
          text: 'パーティの準備はいい？'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: '主人公のお誕生日パーティを準備するのは、いたずら好きな動物？恐竜？もしかして、モンスター？'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'はっちゃめっちゃに進んでいくパーティの準備。あぁ、パーティの準備は無事に終わるのでしょうか。',
        },
      ],
    },
  ],
  reviews: StaryDream.reviews,
};

export default WhosBirthdayTomorrow;
